import React, { useEffect, useState } from 'react';
import '../../styles/home.css';

const Services = () => {

    const [services, setServices] = useState([]);

    useEffect(() => {

        setServices([
            ["Cardiology", "/svg/home-heart.svg"],
            ["Neurology", "/svg/home-brain.svg"],
            ["Oncology", "/svg/home-cancer.svg"],
            ["Gastroenterology", "/svg/home-gastro.svg"],
            ["Pediatrics", "/svg/home-pediatric.svg"],
            ["Dermatology", "/svg/Dermatology.svg"],
            ["Critical Care", "/svg/criticalcare.svg"],
            ["Emergency Services", "/svg/emergencyservices.svg"],
            ["General Medicine", "/svg/general-medicine.svg"],
            ["General Surgery", "/svg/general-surgery.svg"],
            ["Gynaecology & Obstetrics", "/svg/Gynaecology-Obstetrics.svg"],
            ["Orthopedics", "/svg/orthopedics.svg"],
            ["ENT", "/svg/ent.svg"],
            ["Nephrology", "/svg/Nephrology.svg"],
            ["Physiotherapy", "/svg/physiotherapy.svg"],
            ["Pulmonology", "/svg/Pulmonology.svg"],
            ["Urology ", "/svg/urology.svg"],
            ["Radiology", "/svg/radiology.svg"],
            ["Psychiatry", "/svg/psychology.svg"],
        ])
    }, []);

    return (
        <section className="services">
            <h2> Our Services</h2>
            <br />
            <div className="specialities">
                {services.map((sp) => (
                    <div key={sp} className="speciality-card">
                        <div
                            key={sp[0]}
                            style={{
                                width: 50,
                                height: 50,
                                backgroundColor: 'var(--primary-color)',
                                mask: `url(${sp[1]}) no-repeat center`,
                                WebkitMask: `url(${sp[1]}) no-repeat center`,
                                maskSize: "contain",
                                WebkitMaskSize: "contain",
                            }}
                        />
                        <p>{sp[0]}</p>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Services
